import React from 'react';
import { AiRecommendation } from '../customerDetailsTypes';
import styles from './AiRecommendations.module.css';

interface AiRecommendationsProps {
  items: AiRecommendation[];
}

export const AiRecommendations: React.FC<AiRecommendationsProps> = ({ items }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>
        <span className={styles.icon}>✨</span> AI Recommendations
      </h3>
      <div className={styles.list}>
        {items.map((rec) => (
          <div key={rec.id} className={styles.rec}>
            <div className={styles.recHeader}>
              <p className={styles.recTitle}>{rec.title}</p>
              <span className={styles.confidence}>{rec.confidence}</span>
            </div>
            <p className={styles.recDesc}>{rec.description}</p>
            <button className={styles.cta}>{rec.ctaLabel}</button>
          </div>
        ))}
      </div>
    </div>
  );
};
